import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-score-button',
    templateUrl: './document-scoreboard.button.component.html',
    styleUrls: ['./document-scoreboard.button.component.scss'],
    standalone: false
})
export class DocumentScoreboardButtonComponent {
  @Input() ariaLabel: string | null = null;
  @Input() type: string; 
  @Input() dataTestId: string;
  @Input() size: string; 
  @Input() isDisabled: boolean;

  @Output() buttonClick = new EventEmitter();

  get buttonClasses() {
    return ['button', 'button__' + this.type, this.size ? 'button__' + this.size : '']
      .filter((c) => c !== '')
      .join(' ');
  }

  onButtonClick() {
    if (!this.isDisabled) {
      this.buttonClick.emit();
    }
  }
}
